import * as React from 'react';
import AlertDialog from './AlertDialog';

export interface ConfirmProps {
  open: boolean;
  title: string;
  message: string;
  acceptText: string;
  rejectText: string;
  proceed: ((value?: any) => void) | null;
  reject: ((reason?: string) => void) | null;
}

export const ConfirmContext = React.createContext<
  [ConfirmProps, React.Dispatch<React.SetStateAction<ConfirmProps>>] | undefined
>(undefined);

export function ConfirmContextProvider({ children }: any) {
  const [confirm, setConfirm] = React.useState<ConfirmProps>({
    open: false,
    title: '',
    message: '',
    acceptText: 'Agree',
    rejectText: 'Disagree',
    proceed: null,
    reject: null,
  });

  return (
    <ConfirmContext.Provider value={[confirm, setConfirm]}>
      {children}
      <AlertDialog
        open={confirm.open}
        title={confirm.title}
        message={confirm.message}
        rejectText={confirm.rejectText}
        acceptText={confirm.acceptText}
        proceed={confirm.proceed}
        reject={confirm.reject}
      />
    </ConfirmContext.Provider>
  );
}
